import script from "./pingan2024-insured-person.vue?vue&type=script&lang=ts&setup=true"
export * from "./pingan2024-insured-person.vue?vue&type=script&lang=ts&setup=true"

import "./pingan2024-insured-person.vue?vue&type=style&index=0&id=039ef828&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-039ef828"]])

export default __exports__